module.exports = __webpack_public_path__ + "img/cross-gray.eb9c4ec8.svg";